import api from "api/api";

export const canMascaradeAsQuery = async (email) =>
  await api.get(`/auth/can-mascarade/${email}`);

export const getAllRolesQuery = async (roles = []) => {
  const queryParams = roles
    .map((role) => `roles=${encodeURIComponent(role)}`)
    .join("&");
  const url = `/auth/roles${queryParams ? `?${queryParams}` : ""}`;
  return await api.get(url);
};
